module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-speed-dial', {
    staticClass: "ql-add-cue",
    attrs: {
      "md-open": "click",
      "md-direction": "bottom"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button md-mini md-clean",
    attrs: {
      "md-fab-trigger": ""
    }
  }, [_c('md-icon', {
    attrs: {
      "md-icon-morph": ""
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('md-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-fab md-primary md-mini",
    on: {
      "click": _vm.addCue
    }
  }, [_c('md-icon', [_vm._v("note_add")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Add New Cue")])], 1), _vm._v(" "), (_vm.cueToAdd.type == 'position') ? _c('md-button', {
    staticClass: "md-fab md-primary md-mini",
    on: {
      "click": _vm.addText
    }
  }, [_c('md-icon', [_vm._v("text_fields")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Add New Text")])], 1) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-fab md-primary md-mini",
    on: {
      "click": _vm.cancel
    }
  }, [_c('md-icon', [_vm._v("clear")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Cancel")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b311fde","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/project/cues/add-cue-button.vue
// module id = 672
// module chunks = 2